module.exports = __webpack_public_path__ + "img/Citibank.b819b6eb.png";